import $ from 'jquery';
import Masonry from 'masonry-layout';

$(document).ready(function () {
  const $features = $('.m-features');

  //
  $features.each(function () {
    const $list = $(this).find('.list');
    const list = $list[0];

    var msnry = new Masonry(list, {
      itemSelector: '.e-box',
      gutter: 30, // Same as bootstrap
    });
  });

});



// WEBPACK FOOTER //
// ./app/ui/modules/features/index.js